export default __webpack_public_path__ + "static/louis-80d8ec4e4406d8573b4e562c6c32694e.jpg";